import { Box, Typography } from "@mui/material"

export default function NotFound() {
    return (
        <Box>
            <Box display='flex' height='100vh' flexDirection='column' justifyContent='center' alignItems='center'>

                <Typography variant="h4">404 page not found</Typography>
                <Typography variant="body1">OOPS, the page you are looking for doesn't exist.</Typography>
            </Box>
        </Box>
    )
}